<template>
  <div class="home-wrap">
    <div class="home-scroll">
      <header class="home-header">
        <div class="header-action header-action--notice">
          <van-icon
            name="volume"
            size="12"
            @click="$router.push('/notice')"
          />
        </div>
        <img
          v-if="app.logo"
          class="header-logo"
          :src="imageUrl(app.logo)"
          alt=""
        >
        <button
          class="header-action header-action--user"
          type="button"
          :aria-label="$t('homeIndex.personalCenter')"
          @click="$router.push('/user')"
        >
          <van-icon name="contact" />
        </button>
      </header>

      <div
        v-if="notifyStr"
        class="notice-bar"
      >
        <van-icon name="volume" />
        <marquee
          class="notice-bar__text"
          scrollamount="3"
          behavior="scroll"
        >
          {{ notifyStr }}
        </marquee>
      </div>

      <van-swipe
        v-if="banner.length"
        class="hero-swipe"
        :autoplay="3000"
        :show-indicators="false"
        lazy-render
      >
        <van-swipe-item
          v-for="item in banner"
          :key="item.id || item[lang]"
        >
          <img
            class="hero-swipe__image"
            :src="imageUrl(item[lang])"
            alt=""
          >
        </van-swipe-item>
      </van-swipe>

      <main class="home-content">
        <section class="hot-section">
          <div class="section-heading hot-section__heading">
            <span>{{ $t('homeIndex.hot') }}</span>
            <span class="hot-section__subtitle">{{ $t('homeIndex.hotSubtitle') }}</span>
          </div>
          <div
            v-if="hotGirls.length"
            class="hot-grid"
          >
            <button
              v-for="girl in hotGirls"
              :key="girl.id"
              class="hot-card"
              type="button"
              @click="goProfile(girl.id)"
            >
              <img
                :src="imageUrl(girl.pic)"
                :alt="girl.name"
              >
              <span class="hot-card__badge">{{ $t('homeIndex.recommendedBadge') }}</span>
            </button>
          </div>
          <div
            v-else
            class="content-empty"
          >
            {{ $t('homeIndex.emptyHot') }}
          </div>
        </section>

        <section class="ranking-section">
          <h2 class="section-heading">
            {{ $t('homeIndex.popularityRanking') }}
          </h2>
          <div
            v-if="popularityRanking.length"
            class="ranking-list"
          >
            <button
              v-for="(girl, index) in popularityRanking"
              :key="girl.id"
              class="ranking-card"
              type="button"
              @click="goProfile(girl.id)"
            >
              <img
                :src="imageUrl(girl.pic)"
                :alt="girl.name"
              >
              <span>{{ $t('homeIndex.rankingItem', { rank: index + 1 }) }}</span>
            </button>
          </div>
          <div
            v-else
            class="content-empty"
          >
            {{ $t('homeIndex.emptyRanking') }}
          </div>
        </section>

        <section class="home-tabs-section">
          <div
            class="home-tabs"
            role="tablist"
          >
            <button
              v-for="tab in tabs"
              :key="tab.key"
              class="home-tab"
              :class="{ 'home-tab--active': activeTab === tab.key }"
              type="button"
              role="tab"
              :aria-selected="activeTab === tab.key"
              @click="activeTab = tab.key"
            >
              {{ $t(tab.label) }}
            </button>
          </div>

          <div
            v-if="activeTab === 'partners'"
            class="tab-panel partners-grid"
            role="tabpanel"
          >
            <template v-if="partners.length">
              <a
                v-for="partner in partners"
                :key="partner.id || partner.image"
                class="partner-card"
                :class="{ 'partner-card--static': !isPartnerLink(partner.url) }"
                :href="isPartnerLink(partner.url) ? partner.url : null"
                :target="isPartnerLink(partner.url) ? '_blank' : null"
                :rel="isPartnerLink(partner.url) ? 'noopener noreferrer' : null"
              >
                <img
                  :src="imageUrl(partner.image)"
                  alt=""
                >
              </a>
            </template>
            <div
              v-else
              class="content-empty"
            >
              {{ $t('homeIndex.emptyPartners') }}
            </div>
          </div>

          <div
            v-else-if="activeTab === 'dating-records'"
            class="tab-panel dating-records"
            role="tabpanel"
          >
            <van-swipe
              class="dating-records__swipe"
              :autoplay="2400"
              vertical
              :show-indicators="false"
            >
              <van-swipe-item
                v-for="(recordGroup, index) in dateRecordGroups"
                :key="index"
              >
                <div
                  v-for="record in recordGroup"
                  :key="record"
                  class="dating-record"
                >
                  {{ record }} {{ $t('homeIndex.successfulDate') }}
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>

          <div
            v-else
            class="tab-panel company-profile"
            role="tabpanel"
          >
            <van-loading
              v-if="companyProfileLoading"
              size="24px"
            >
              {{ $t('homeIndex.loadingCompanyProfile') }}
            </van-loading>
            <div
              v-else-if="companyProfile && companyProfile.content"
              class="company-profile__content"
              v-html="companyProfile.content"
            />
            <div
              v-else
              class="content-empty"
            >
              {{ companyProfileFailed ? $t('homeIndex.companyProfileFailed') : $t('homeIndex.emptyCompanyProfile') }}
            </div>
          </div>
        </section>
      </main>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import api from '../../interface/index';
import Fetch from '../../utils/fetch';
import {
  Icon,
  Loading,
  Swipe,
  SwipeItem
} from 'vant';

Vue.use(Icon).use(Loading).use(Swipe).use(SwipeItem);

export default {
  name: 'Index',
  components: {
    VanSwipe: Swipe,
    VanSwipeItem: SwipeItem
  },
  data() {
    return {
      lang: this.$i18n.locale || 'en_us',
      app: {},
      notifyStr: '',
      banner: [],
      hotGirls: [],
      popularityRanking: [],
      partners: [],
      companyProfile: null,
      companyProfileLoading: true,
      companyProfileFailed: false,
      activeTab: 'partners',
      tabs: [
        { key: 'partners', label: 'homeIndex.partners' },
        { key: 'dating-records', label: 'homeIndex.datingRecords' },
        { key: 'company-profile', label: 'homeIndex.companyProfile' }
      ],
      dateRecords: [
        '4oP****xpW',
        'xun****kDJ',
        '0YQ****FFq',
        'LFX****nQ3',
        'Kpr****2D9',
        'Cb6****r64',
        'bMq****bxT',
        'kxX****RSF',
        'aDz****W7m',
        'nVq****L8c'
      ]
    };
  },
  computed: {
    dateRecordGroups() {
      const groups = [];
      const groupSize = 5;
      for (let index = 0; index < this.dateRecords.length; index += groupSize) {
        groups.push(this.dateRecords.slice(index, index + groupSize));
      }
      return groups;
    }
  },
  created() {
    this.$parent.footer('home');
  },
  mounted() {
    if (!localStorage.getItem('token')) {
      this.$router.push('/login');
      return;
    }
    this.loadHome();
    this.loadWebConfig();
  },
  methods: {
    loadHome() {
      Fetch('/index/int').then((response) => {
        const data = response.data || {};
        this.banner = data.banner || [];
        this.notifyStr = data.notice || '';
        this.hotGirls = data.hot_girls || [];
        this.popularityRanking = data.popularity_ranking || [];
        this.partners = data.partners || [];
        this.companyProfile = data.company_profile || null;
        this.companyProfileLoading = false;
      }).catch(() => {
        this.companyProfileLoading = false;
        this.companyProfileFailed = true;
      });
    },
    loadWebConfig() {
      Fetch('/index/webconfig').then((response) => {
        this.app = response.data || {};
      });
    },
    goProfile(id) {
      if (id) {
        this.$router.push('/vprofile/' + id);
      }
    },
    imageUrl(imagePath) {
      if (!imagePath || /^(?:https?:)?\/\//.test(imagePath) || imagePath.indexOf('data:') === 0) {
        return imagePath;
      }

      const baseUrl = (api.commonUrl || '').replace(/\/$/, '');
      const relativePath = imagePath.charAt(0) === '/' ? imagePath : '/' + imagePath;

      return baseUrl + relativePath;
    },
    isPartnerLink(url) {
      return typeof url === 'string' && /^https?:\/\//i.test(url);
    }
  }
};
</script>

<style lang="less" scoped>
.home-wrap {
  width: 100%;
  min-height: 100vh;
  background: #fff;
  overflow-x: hidden;
}

.home-scroll {
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 76px;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
}

.home-header {
  position: relative;
  height: 60px;
  background: linear-gradient(105deg, #df54bd, #7244c9);
}

.header-logo {
  position: absolute;
  top: 5px;
  left: 50%;
  // width: 64px;
  height:50px;
  object-fit: contain;
  transform: translateX(-50%);
}

.header-action {
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height:60px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #fff;
  font-size: 14px;
}

.header-action--notice {
  left: 0;
  color: #ffba29;
}

.header-action--user {
  right: 0;
}

/deep/ .header-action .van-icon {
  transform: scale(2);
}

.notice-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 60px;
  padding: 0 24px;
  color: #17233f;
  font-size: 14px;
  box-sizing: border-box;
}

.notice-bar__text {
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
}

.hero-swipe {
  width: calc(100% - 24px);
  // height: 214px;
  margin: 0 auto;
  border-radius: 5px;
  overflow: hidden;
}

/deep/ .hero-swipe .van-swipe__track,
/deep/ .hero-swipe .van-swipe-item {
  height: 100%;
}

.hero-swipe__image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.home-content {
  padding: 14px 18px 0;
}

.section-heading {
  margin: 0 0 8px;
  color: #102139;
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
}

.hot-section__heading {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 400;
}

.hot-section__subtitle {
  padding: 2px 12px;
  border-radius: 4px;
  background: #3f3b5f;
  color: #f7d5a3;
  font-size: 14px;
  line-height: 20px;
}

.hot-grid {
  --hot-card-size: calc((100vw - 68px) / 5);
  display: grid;
  grid-auto-columns: var(--hot-card-size);
  grid-template-rows: repeat(2, var(--hot-card-size));
  grid-auto-flow: column;
  gap: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 2px;
  scroll-snap-type: x proximity;
  -webkit-overflow-scrolling: touch;
}

.hot-card,
.ranking-card {
  padding: 0;
  border: 0;
  background: transparent;
  text-align: center;
}

.hot-card {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 5px;
  scroll-snap-align: start;
}

.hot-card img,
.ranking-card img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hot-card__badge {
  position: absolute;
  top: 7px;
  right: -21px;
  width: 76px;
  padding: 2px 0;
  background: rgba(239, 214, 184, .92);
  color: #715846;
  font-size: 10px;
  font-style: normal;
  transform: rotate(45deg);
}

.ranking-section {
  margin-top: 20px;
}

.ranking-list {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  padding: 8px 0 4px;
}

.ranking-card {
  color: #251176;
  font-size: 12px;
  font-weight: 700;
  line-height: 17px;
}

.ranking-card img {
  height: auto;
  aspect-ratio: 4 / 5;
  margin-bottom: 8px;
  border-radius: 12px;
}

.home-tabs-section {
  margin-top: 28px;
}

.home-tabs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
}

.home-tab {
  min-width: 0;
  padding: 8px 4px;
  border: 0;
  border-radius: 20px;
  background: #a4a4a4;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
}

.home-tab--active {
  background: linear-gradient(105deg, #df54bd, #7244c9);
}

.tab-panel {
  min-height: 150px;
  margin-top: 10px;
}

.partners-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  align-items: center;
  gap: 12px 22px;
  padding: 12px 16px;
  box-sizing: border-box;
}

.partner-card {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 58px;
}

.partner-card--static {
  cursor: default;
}

.partner-card img {
  display: block;
  width: 100%;
  max-height: 68px;
  object-fit: contain;
}

.dating-records {
  overflow: hidden;
  border-radius: 12px;
  background: linear-gradient(105deg, #df54bd, #7244c9);
}

.dating-records__swipe {
  height: 200px;
}

.dating-record {
  height: 40px;
  color: #fff;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
}

.company-profile {
  min-height: 150px;
  padding: 16px 14px;
  border-radius: 12px;
  background: linear-gradient(105deg, #df54bd, #7244c9);
  color: #fff;
  box-sizing: border-box;
}

.company-profile__content {
  font-size: 14px;
  line-height: 1.75;
  word-break: normal;
  overflow-wrap: normal;
}

/deep/ .company-profile__content * {
  max-width: 100%;
  color: inherit !important;
  word-break: normal !important;
  overflow-wrap: normal !important;
}

/deep/ .company-profile__content img {
  height: auto;
}

.content-empty {
  width: 100%;
  padding: 24px 10px;
  color: #8b8b8b;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  box-sizing: border-box;
}

.company-profile .content-empty {
  color: #fff;
}

@media (max-width: 360px) {
  .home-content {
    padding-right: 12px;
    padding-left: 12px;
  }

  .home-tab {
    font-size: 12px;
  }

  .hot-section__subtitle {
    padding-right: 8px;
    padding-left: 8px;
    font-size: 12px;
  }
}
.ranking-card span{
	word-wrap: break-word;
	word-break: break-word;
}
.company-profile__content p{
	word-wrap: break-word;
	word-break: break-word;
}
</style>
